import { type IconProps } from "@chakra-ui/react";
import { DbtIcon, FivetranIcon, LookerIcon, SigmaIcon, TableauIcon } from "ui/icons/extensions";

export type PricingDetailsProps = {
  title: string;
  features: Array<{
    /** Column span out of 4 */
    colSpan: number;
    title: string;
    items: string[];
  }>;
};

export const pricingDetails: PricingDetailsProps[] = [
  {
    title: "Full observability",
    features: [
      {
        colSpan: 2,
        title: "Observability features included",
        items: [
          "Live debugger",
          "Custom alerting (by sync)",
          "Test runs (test-a-row)",
          "In-app sync logs",
          "Basic alerting",
          "Warehouse sync logs",
        ],
      },
      {
        colSpan: 2,
        title: "Sync planning and caching methods included",
        items: ["Run on Hightouch", "Run on your warehouse", "Run on your custom storage"],
      },
    ],
  },
  {
    title: "Enterprise-level security",
    features: [
      {
        colSpan: 2,
        title: "Security, privacy certifications and features",
        items: [
          "ISO 27001 Certified",
          "SOC 2 & SOC 3 Compliance",
          "HIPAA Compliance",
          "GDPR Compliance",
          "Deployment in EU region",
          "Deployment in multiple regions",
          "SSH tunneling",
          "Custom Security Review (BAA, DPA, full SOC2 report)",
        ],
      },
      {
        colSpan: 1,
        title: "Access management features",
        items: [
          "Role-based access control",
          "Label-based access control",
          "Google and Azure SSO",
          "SAML SSO (Okta, Azure AD, OneLogic, etc.)",
        ],
      },
      {
        colSpan: 1,
        title: "Platform management features",
        items: ["Git version control", "Approval flows", "Audit logs", "Resource API"],
      },
    ],
  },
  {
    title: "Support and security",
    features: [
      {
        colSpan: 2,
        title: "Support",
        items: [
          "Dedicated shared Slack",
          "Dedicated CSM",
          "White glove onboarding",
          "Dedicated services",
          "Dedicated solutions architect",
        ],
      },
      {
        colSpan: 2,
        title: "Service-level agreements (SLAS)",
        items: ["Custom product uptime SLA", "Custom support SLA", "Email & Intercom Support"],
      },
    ],
  },
];

export type PricingExtensionProps = {
  title: string;
  features: Array<{
    title: string;
    icon: (props: IconProps) => JSX.Element;
  }>;
};

export const pricingExtensions: PricingExtensionProps = {
  title: "Premium extensions",
  features: [
    {
      title: "dbt model selector (git rep)",
      icon: DbtIcon,
    },
    {
      title: "dbt Cloud sync scheduler",
      icon: DbtIcon,
    },
    {
      title: "Fivetran sync scheduler",
      icon: FivetranIcon,
    },
    {
      title: "Looker model selector",
      icon: LookerIcon,
    },
    {
      title: "Tableau integration",
      icon: TableauIcon,
    },
    {
      title: "Sigma workbook integration",
      icon: SigmaIcon,
    },
  ],
};
